import * as React from "react";
import {useState, useEffect} from "react";
import { jfetch } from "../../utils";
import { toast } from "../../utils";
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";

function PollsAdmin(props) {

  // useEffect(() => {
  // }, [])

  const [question, setQuestion] = useState('')
  const [choices, setChoices] = useState('')

  const createQuestion = () => {
    jfetch.post(`/poll/questions`, {
      poll_question: {
        info: question,
        active: true
      },
      choices: choices
    })
    .then((resp) => {
      toast.success('Question was added')
      setQuestion('')
      setChoices('')
    })
  }

  return (
    <PageContainer>
      <ModernCard ta="left">
        <div>
          <h2>New Poll</h2>
        </div>
        <div>
          <label>Survey Question</label>
          <input type="text" className="form-control" value={question} onChange={(e) => setQuestion(e.target.value) } />
          <label>Choices (seperated by commas if multiple)</label>
          <input type="text" className="form-control" value={choices} onChange={(e) => setChoices(e.target.value) } />     
          <button className="btn btn-primary" onClick={createQuestion}>Create</button>    
        </div>
      </ModernCard>      
      <ModernCard ta="left">
        <div>
          <h2>Polls</h2>
        </div>
        {props.questionsWCount.map((question) => {
          const c = question.active ? 'black' : 'red';
          return (
            <div key={question.id}>
              <a style={{color:c}} href={`/poll/questions/${question.id}`}>
                <h2>
                  {question.info} - answers: {question.answerCount}
                </h2>
              </a>
            </div>
          )
        })}
      </ModernCard>
    </PageContainer>
  );
}

export default PollsAdmin;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/PollsAdmin.tsx